module.exports = __webpack_public_path__ + "media/images/icons/outlined/usb-50d18d7155fdb68ca3c8658dc302d2da.svg";